import { FC, ReactNode } from 'react';
import cindyChatAvatar from '/public/img/ai/cindy-chat-avatar.png';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

type AiMessageProps = {
  children: ReactNode;
  timestamp: string;
};

export const AiMessage: FC<AiMessageProps> = ({ children, timestamp }) => {
  return (
    <Box display='flex'>
      <Box display='flex' alignItems='start'>
        <Avatar
          alt='Cindy'
          src={cindyChatAvatar.src}
          sx={{ width: 52, height: 52, mr: 1 }}
        />
      </Box>
      <Box display={'flex'} flexDirection={'column'} mb={2}>
        <Typography variant='subtitle1' fontWeight={'bold'}>
          Cindy
        </Typography>
        <Box
          sx={{
            backgroundColor: '#F1F7FF',
            borderRadius: '0px 10px 10px 10px',
            color: '#000',
            p: 1,
          }}
        >
          <Typography variant='body1' p={0.5}>
            {children}
          </Typography>
        </Box>
        <Typography
          variant='subtitle2'
          color={'primary.main'}
          textAlign={'right'}
        >
          {timestamp}
        </Typography>
      </Box>
    </Box>
  );
};
